
export const SUPPORT_MAX_URL =
  'https://max.ru/u/f9LHodD0cOJJoQ89YbexhYET5ZWV4LBYPILtXdbPMp0RT3ejAoza2fDmhP4'
export const SUPPORT_TELEGRAM_URL = 'https://t.me/speakalot_eng'
